export default function adminFetch(input, init = {}) {
  return fetch(input, {
    credentials: "include",
    mode: "cors",
    cache: "default",
    ...init,
  });
}
